import colors from './colors'
import fonts from './fonts'
import shadows from './shadows'

const theme = {
  colors,
  fonts,
  shadows,
  fontSizes:fonts.fontSizes,
  headerSize: '60px',
  footerSize: '100px'
}

export default theme;